module.exports = __webpack_public_path__ + "img/euro.70b900c8.svg";